export const PAGE_LOADER_TEXT = "Please wait while we set things up for you...";
export const PROCESSING_TRASACTION_TEXT = "Processing transaction...";
export const TRANSACTION_FAILURE_TEXT =
  "Transaction failed, please try again :(";
export const REJECTED_TEXT = "User rejected the request.";
export const CONNECTING_WALLET_TEXT = "Connecting Wallet...";
export const WALLET_CONNECTION_SUCCESS_TEXT = "Wallet connected successfully!";
export const WALLET_CONNECTION_FAILUE_TEXT =
  "Connection failed, please try again :(";
export const BANNER_TEXT = `We are in alpha mode right now`;
export const NO_WALLET_DETECTED_TEXT =
  "Earn the highest staking rewards possible by staking MATIC, with the power of our auto-compounding feature.";

export const AVAIALABLE_TO_BE_CLAIMED = "Available to be Claimed";

export const TERMS_URL = "https://staderlabs.com/terms-of-service";
export const CAPPED_ADVISORY =
  "Capped Launch: Please limit individual staked amounts to 10,000 Matic.";
export const TVL_REACHED_MESSAGE =
  "TVL for Capped Launch has been reached. We'll be lifting caps on 18th April. Please check back in again.";

export const TVL_TOOLTIP_TEXT = "Total Matic Staked";
export const APY_TOOLTIP_TEXT = "Average Annual Staking Rewards";
export const AUDIT_TOOLTIP_TEXT = "Click to know more on audits";
export const UNSTAKE_LIMIT_TOOLTIP_TEXT =
  "The maximum amount that can be unstaked at the moment. Limit will be refreshed shortly.";

export const NETWORK_KEY = "current-network-id";

export const STADER_URL = "https://staderlabs.com/";
export const TWITTER_URL = "https://twitter.com/stader_polygon";
export const TELEGRAM_URL = "https://t.me/StaderLabs_Polygon_Official";
export const DISCORD_URL = "https://discord.gg/ReasyJB4Rq";

export const SUBSCRIBE_URL = "https://forms.gle/zde385SfnSa9kCMY8";
